import type { useWindowDimensionsInterface } from "@dealer-center/core-custom-components";

export * from "./bottomBar";
export * from "./page-template";
export * from "./page-template-components";

export const shouldPinLinksMenu = (
  windowDimensions: useWindowDimensionsInterface
) => windowDimensions.is4xlOrGreater;
